import React from 'react';
import './App.css';
import logos from './logos.svg';
import users from './users.svg';
import firebase from "firebase/app";
import { Component,  useRef, createContext, useState, useEffect, useContext, useCallback, Suspense, createRef  }  from 'react';
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import slide_2 from './images/slide_2.png';
import raphael from './raphael.jpg';
import slide_3 from './images/slide_3.png';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Sketchpad from './Sketchpad.png';
import status from './status.png';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Button from '@material-ui/core/Button';
import { Link, Router } from "@reach/router";
import status1 from './status1.png';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import CommentIcon from '@material-ui/icons/Comment';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AddStatuses from './AddStatus.js';
import ViewStreamIcon from '@material-ui/icons/ViewStream';



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    backgroundColor: theme.palette.background.paper,
  },

 
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));
       

export default function SlideShows () {
	
  const user = firebase.auth().currentUser;


   	const [modal, setModal] = useState(0);

  const [slimy, setSLimy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalLikes, setTotalLikes] = useState([]);
  const [limits, setLimits] = useState(3);





  useEffect(() => {
    const subscriber = firebase.firestore()
    .collection('StudentStatus').orderBy('createdAt', 'desc').limit(limits)
      .onSnapshot(querySnapshot => {
        const users = [];

        querySnapshot.forEach(documentSnapshot => {
          users.push({
            ...documentSnapshot.data(),
            key: documentSnapshot.id,
          });
        });
        setSLimy(users);
        setLoading(false);

        
      });

      

    // Unsubscribe from events when no longer in use
    return () => subscriber();
  }, [limits]);

  




const [isBottom, setIsBottom] = useState(false);


function handleScroll() {
const scrollTop = (document.documentElement
      && document.documentElement.scrollTop)
      || document.body.scrollTop;


      const scrollHeight = (document.documentElement
      && document.documentElement.scrollHeight)
      || document.body.scrollHeight;


      if (scrollTop + window.innerHeight + 5 >= scrollHeight) {
      setIsBottom(true);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

useEffect(() => {
  if (isBottom) {
setLimits(limits + 1);
  }
}, [isBottom]);



const currentTime = new Date().getTime();

const [liked, setLiked] = useState(true);
const [disLiked, setDisLiked] = useState(true);



const CustomItem = (item) => {
    // <----------------
   const [likesCount, setLikesCount] = useState([]);


    useEffect(() => {


 firebase.firestore()
    .collection(`StudentStatus/${item.time}/likes`)
      .onSnapshot(querySnapshot => {
        const users = [];

        querySnapshot.forEach(documentSnapshot => {
          users.push({
            ...documentSnapshot.data(),
            key: documentSnapshot.id,
          });
        });
        setLikesCount(users);
        setLoading(false);


      });


    }, [item.time]);

async function addNewLike () {
  await firebase.firestore().doc(`StudentStatus/${item.time}/likes/${user.uid}`).set({
        id: user.uid,
        avatar: user.photoURL,
        name: user.displayName

      
  })
setLimits(limits + 1);
console.log(likesCount);
}

async function removeItemAll() {
 likesCount.filter(item => item.id !== user.id);
console.log('like removed');
setLikesCount(likesCount);
 await firebase.firestore().doc(`StudentStatus/${item.time}/likes/${user.uid}`).delete()
  .then(() => {
    console.log('User deleted!');
  });

}



const ImagesSlide = (item) => {

return(
 <ListItem key={item.id}><p>{item.name}</p></ListItem>)
} 

function seeMore () {
setModal(item.time);
setLimits(limits + 1);


}

function seeLess () {
setModal(0);
setLimits(limits + 1);


}
console.log(limits);

   return (
     <ListItem key={item.createdAt} style={{ display: 'flex', justifyContent: 'center'}}>

<div style={{display: 'flex', width: '90%', height: 'auto',  justifyContent: 'center',   borderRadius: 10 ,  }}  > <Suspense fallback={<p>post is loading</p>}>
<Paper classes={{ padding: 0 }} style={{ display: 'flex',   flexDirection: 'column',  alignContent: 'center', padding: 0, justifyContent: 'space-between' }} >
      
      <Typography  variant="body1" component="p">
            <p className="title">{item.Title}</p>
          </Typography>
     
      {item.MediaType.includes('image')? <img src={item.Image} loading='lazy' width={ window.screen.availHeight > window.screen.availWidth ? window.screen.availWidth * 0.95 : window.screen.availWidth * 0.8  } height={ window.screen.availHeight > window.screen.availWidth ? null : window.screen.availHeight * 0.8  } style={{objectFit:'contain'}}    alt={item.Description}  /> : item.MediaType.includes('video') ? <video preload='metadata' src={item.Image} loop={true}  width={ window.screen.availHeight > window.screen.availWidth ? window.screen.availWidth * 0.95 : window.screen.availWidth * 0.8  } style={{objectFit:'contain'}} height={ window.screen.availHeight > window.screen.availWidth ? null : window.screen.availHeight * 0.8  }  controls controlsList='nodownload nofullscreen noremoteplayback'  /> : null }
      

      
        
     
      <CardActions style={{justifyContent: 'space-between', alignItems: 'center', display: 'flex', flexDirection: 'column' }} >
     

          { !item.Image ?  <Typography paragraph style={{fontSize: 'calc(2px + 2vmin)'}} >{item.Description}</Typography> : null }

       <div style={{display: 'flex', flexDirection: 'row'}} >

       <div style={{display: 'flex', flexDirection: 'row'}} >
       


        <IconButton onClick={likesCount.map(item => item.id).includes(user.uid)? removeItemAll :  addNewLike }  ><p style={{fontSize: 'calc(2px + 1vmin)'}} >{likesCount.length}</p>
          <FavoriteIcon color={likesCount.map(item => item.id).includes(user.uid) ?"secondary" : 'disabled'} />
        </IconButton>
        </div>


       { !item.Image ? <IconButton><Link to='post' className="header-icons" ><CommentIcon/></Link></IconButton> : modal !== item.time ?<IconButton
          
          onClick={seeMore}
          
        > 
          <ExpandMoreIcon />
        </IconButton>
        :<IconButton
          
          onClick={seeLess}
          
        > 
          <ExpandLessIcon />
        </IconButton>}

         <div style={{display: 'flex', flexDirection: 'row'}} >
       <p>{item.disLikes}</p>
<IconButton onClick={() => setDisLiked(!disLiked)} >
        <FontAwesomeIcon icon={faHeartBroken} color={likesCount.map(item => item.id).includes(user.uid)  ?"grey" : 'red[500]'} />  
        </IconButton> 
        </div>    
        </div>    
      </CardActions>
      { !item.Image ? null : <Collapse in={modal == item.time ? true : false } timeout="auto" style={{backgroundColor: 'lightgrey'}} unmountOnExit>
        <CardContent style={{display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent:'center',alignSelf: 'center' }} >
          <i paragraph style={{fontSize: 'calc(2px + 2vmin)',padding:'3%' }} >{item.Description}</i>

<u onClick={() => window.open(item.Link)  } style={{padding:'3%' }} >{item.linkCaption}</u>


<div className="post-user">
<CardHeader
        avatar={
          <Avatar aria-label="user" src={item.avatar}/>
          
        }
      
        title={item.displayName}
        subheader={item.Occ}
      /> 

      <CommentIcon className="CommentIcon" color="action"/>
        </div>


        </CardContent>


      </Collapse>}
    </Paper>
    </Suspense>

      </div>


</ListItem>
   )
}
  
  const [streams, setStreams] = useState('');
  const constraints = {
  video: true,
  audio: true,
};

var chunks = [];

const recordedBlobs = [];
var recordedChunks = [];


const videos = createRef(null);
const remoteVideo = createRef(null);
  
const [loadingDescription, setLoadingDescription] = useState('');

let localStream;
let remoteStream;
let roomId;
let roomIdData = [];
let peerConnection;


let configuration = {
    'iceServers': [
      {'urls': 'stun:stun.services.mozilla.com'},
      {'urls': 'stun:stun.l.google.com:19302'},
    ]
  }

 function recordLive () {

  navigator.mediaDevices.getUserMedia({ video: true}).then( async (localStream, remoteStream)  => {

      console.log(localStream);

  videos.current.srcObject = localStream;

  videos.current.onloadedmetadata = function(e) {
    videos.current.play();
  };

 remoteStream = new MediaStream();
        remoteVideo.current.srcObject = remoteStream;


 peerConnection = new RTCPeerConnection(configuration);

    localStream.getTracks().forEach(track => {
        peerConnection.addTrack(track, localStream)
    })

     const roomRef = firebase.firestore.collection("StudentStatus").doc();
    const callerCandidatesCollection = roomRef.collection("callerCandidates");

    peerConnection.addEventListener("icecandidate", event => {
      if(!event.candidate){
       //  console.log("Got Final Candidate!");
        return;
      }
     //  console.log('Got candidate: ', event.candidate);
     callerCandidatesCollection.add(event.candidate.toJSON());
    })

     const offer = await peerConnection.createOffer();
     await peerConnection.setLocalDescription(offer);

     const roomWithOffer = {
       'offer': {
         type: offer.type,
         sdp: offer.sdp,
       },
       roomId: roomRef.id
     };
     await roomRef.set(roomWithOffer);
     roomId = roomRef.id;
     console.log(roomId)

peerConnection.addEventListener("track", event => {
        // console.log('Got remote track:', event.streams[0]);
        event.streams[0].getTracks().forEach(track => {
          // console.log('Add a track to the remoteStream:', track);
          remoteStream.addTrack(track);
        })
       })
// Optional frames per second argument.

 

})
}

function reloadVideoStream () {
   setInterval(event => {
 
recordLive();

}, 9000);

}

function getStream(videoElem) {

  const stream = videos.current.srcObject;
  const tracks = stream.getTracks();

  tracks.forEach(function(track) {
    track.stop();
  });
console.log(tracks);
  videos.current.srcObject = null;
}

function newPost () {
  setAddPost("Add")
}

function viewStreams() {
   setAddPost("null")
}

const [addPost, setAddPost] = useState("null")
if (loading) {
  return <p>please wait a bit</p>;
}
  return (
    <div style={{backgroundColor:'whitesmoke', display: 'flex', height: '100%', flexDirection: 'column', justifyContent: 'center', width: '100%', marginTop: window.screen.availHeight > window.screen.availWidth ? '8%' : '5%', alignItems: 'center',alignContent: 'center',alignSelf: 'center' }}>
   
<div className="posts-header" style={{ position: 'sticky', }} >
<p className="posts-head" >Trending</p>
<p className="post-head">Engineering</p>
<p className="post-head">Sciences</p>
<p className="post-head">Humanities</p>
<p className="post-head">Commerce</p>
<p className="post-head">memes</p>
<p className="post-head">dark</p>
</div>
{ addPost === "null" 
?<AddBoxIcon className="addIcon" onClick={newPost} />:
<ViewStreamIcon className="addIcon" onClick={viewStreams} />}

{addPost === "null" ?
<List component="ul" aria-label="main mailbox folders">
{slimy.map(function(item){

      
      return (

<CustomItem key={item.createdAt} time={item.time} Description={item.Description} Image={item.Image} Link={item.Link} MediaType={item.MediaType} Occ={item.Occ} Title={item.Title} avatar={item.avatar} displayName={item.displayName} linkCaption={item.linkCaption}  />
      )
}
)}
      </List>:
      <AddStatuses/>}
      <Divider />



   <p>You have viewed {slimy.length} posts, interact with at least one more to see 10 more, to experience smooth scrolling, interact before reaching here</p>   
    
<video ref={videos}  autoPlay defaultmuted = 'true'   ></video>
   <Button onClick={recordLive}>Record</Button>
   <Button onClick={getStream}>stop</Button>
   <video ref={remoteVideo} autoPlay></video>


    </div>)

}

